<template>
  <v-row
    justify="space-around"
  >
    <v-col
      cols="12"
    >
      <!-- Médaillon Challenges -->
      <stats-template
        :is-loading="isLoading.challenges"
        :has-error="hasError.challenges"
        :error-msg="errorMsg"
        icon="mdi-arm-flex"
        :title="$t(title.challenges)"
        :value="data.challenges"
        color="primary"
        :small-height="true"
      />
    </v-col>
    <v-col
      cols="12"
    >
      <!-- Médaillon Quizz -->
      <stats-template
        :is-loading="isLoading.quizz"
        :has-error="hasError.quizz"
        :error-msg="errorMsg"
        icon="mdi-check-decagram "
        :title="$t(title.quizz)"
        :value="data.quizz"
        color="secondary"
        :small-height="true"
      />
    </v-col>
    <v-col
      cols="12"
    >
      <!-- Médaillon Mondes -->
      <stats-template
        :is-loading="isLoading.worlds"
        :has-error="hasError.worlds"
        :error-msg="errorMsg"
        icon="mdi-earth"
        :title="$t(title.worlds)"
        :value="data.worlds"
        color="bluecolor"
        :small-height="true"
      />
    </v-col>
  </v-row>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import StatsTemplate from './templates/StatsTemplate.vue'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'StatsTraining',

    /* Sous-composants utilisés par ce composant */
    components: {
      StatsTemplate,
    },

    /* Paramètres */
    props: {
      request: {
        type: String,
        default: '',
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
      errorMsg: {
        type: String,
        default: 'Erreur',
      },
      color: {
        type: String,
        default: 'primary',
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        title: {
          quizz: 'Stats.Training.Quizz.Title',
          challenges: 'Stats.Training.Challenges.Title',
          worlds: 'Stats.Training.Worlds.Title',
        },
        data: {
          quizz: undefined,
          challenges: undefined,
          worlds: undefined,
        },
        isLoading: {
          quizz: true,
          challenges: true,
          worlds: true,
        },
        hasError: {
          quizz: false,
          challenges: false,
          worlds: false,
        },
      }
    },

    /* Variables surveillées : traitement si modification de sa valeur */
    watch: {
      request: function (newVal, oldVal) {
        this.fetchAllStats()
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.fetchAllStats()
    },

    /* Fonctions internes */
    methods: {
      fetchAllStats: function () {
        this.isLoading.quizz = true
        this.isLoading.challenges = true
        this.isLoading.worlds = true
        this.fetchCountStats('challenges')
        this.fetchCountStats('succeedQuizz')
        this.fetchCountStats('succeedWorlds')
      },

      // Récupération des données statistiques
      fetchCountStats: function (type) {
        let url = ''
        switch (type) {
          case 'challenges':
            url = 'selectChallengeSucceedCount'
            break
          case 'succeedQuizz':
            url = 'selectQuizzSucceedCount'
            break
          case 'succeedWorlds':
            url = 'selectWorldSucceedCount'
            break
        }
        if (url.length) {
          this.$Auth.httpRequest(
            'get',
            'api/dashboard/count/' + url + this.request,
          ).then(datas => {
            switch (type) {
              case 'challenges':
                this.data.challenges = datas.data[0].count
                break
              case 'succeedQuizz':
                this.data.quizz = datas.data[0].count
                break
              case 'succeedWorlds':
                this.data.worlds = datas.data[0].count
                break
            }
          }).catch((error) => {
            switch (type) {
              case 'challenges':
                this.hasError.challenges = false
                this.data.challenges = undefined
                break
              case 'succeedQuizz':
                this.hasError.quizz = false
                this.data.quizz = undefined
                break
              case 'succeedWorlds':
                this.hasError.worlds = false
                this.data.worlds = undefined
                break
            }
            /* if (this.isAdmin) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            } */
            this.$emit('set-error', error)
          }).finally(() => {
            switch (type) {
              case 'challenges':
                this.isLoading.challenges = false
                break
              case 'succeedQuizz':
                this.isLoading.quizz = false
                break
              case 'succeedWorlds':
                this.isLoading.worlds = false
                break
            }
          })
        }
      },
    },
  }
</script>
